// extracted by mini-css-extract-plugin
export default {"container":"QuestionDetails-module__container--KM0Tl"};